






















































































































































































































































































































































































































































































































































































































import { getReport, employeesList, userDetails } from '@/api/api.config'
import { Component, Vue } from 'vue-property-decorator'
import html2canvas from 'html2canvas'
import router from '@/router/router'
@Component
export default class Bari extends Vue {
  orderId: any = ''
  list: any = []
  online: any = {}
  offline: any = {}
  onlines: any = []
  thirdParty: any = {}
  Overlay = false
  bgimgs: any = {}
  souh: any = 0
  project: any = {}
  reqdata: any = ''
  canvasImageUrl: any = ''
  isDom: any = true
  Charts(res: any) {
    let res1 = res.data.data.offlineitemsDataEntities
    var indicators: any = []
    var bmsTotalCurrent = {
      text: 'BMS总电流测量精度',
      result: res1.bmsTotalCurrentResult,
      num: res1.bmsTotalCurrentValue + '%',
    }
    var bmsVoltage = {
      text: 'BMS总电压测量精度',
      result: res1.bmsVoltageResult,
      num: res1.bmsVoltageValue + '%',
    }
    var socDeviation = {
      text: '电池SOC估计误差',
      result: res1.socDeviationResult,
      num: res1.socDeviationValue + '%',
    }
    var sohCheck = {
      text: 'SOH',
      result: res1.sohCheckResult,
      num: res1.sohCheckValue+'%',
    }
    var tempDifference = {
      text: '动力电池温差',
      result: res1.tempDifferenceResult,
      num: res1.tempDifferenceValue + '℃',
    }
    indicators.push(bmsTotalCurrent)
    indicators.push(bmsVoltage)
    indicators.push(socDeviation)
    indicators.push(sohCheck)
    indicators.push(tempDifference)
    var chartDom = document.getElementById('main')
    var myChart = (this as any).$echarts.init(chartDom)
    let arrs = res.data.data.offlineitemsDataEntities
    // let arres = res.data.onlineitemsDataEntities;
    let arr = []
    let sohDampValue = parseInt(arrs.sohCheckValue)
    arr.push(
      // Bms总电流
      arrs.bmsTotalCurrentValue,
      // arrs.equalResistanceValue,
      // arrs.equalResistanceScoreValue,
      arrs.tempDifferenceValue,
      sohDampValue,
      // arrs.resistanceCheckValue,
      arrs.socDeviationValue,
      // arrs.currentExcessValue,
      // arrs.voltageExcessValue,
      arrs.bmsVoltageValue,
    )
    // console.log(arr);
    var option
    option = {
      title: {
        text: '',
      },

      textStyle: {
        // color: "#5EACCC",
        // textShadowColor: "#aaa",
        // textShadowBlur: 3,
        // textShadowOffsetY: 2,
        fontSize: 12,
      },

      tooltip: {
        trigger: 'axis',
      },

      legend: {
        center: 'center',
        data: [''],
      },
      radar: {
        name: {
          formatter: (value: any) => {
            console.log(value, '测试')

            var res = ''
            var num
            indicators.forEach((e: any) => {
              if (e.text == value) {
                res = e.result
                num = e.num
              }
            })

            const arr = []
            if (res == '优秀') {
              arr.push(`{a|${num}}  {g|${res}}`)
            } else if (res == '较差') {
              arr.push(`{a|${num}}  {r|${res}}`)
            } else {
              arr.push(`{a|${num}}  {l|${res}}`)
            }
            arr.push(`{s|${value}}`)
            return arr.join('\n') // 数组转成字符串并换行
          },

          rich: {
            a: {
              fontSize: 12,
              color: '#000',
            },
            r: {
              fontSize: 12,
              color: 'red',
              // align: "center",
            },
            g: {
              fontSize: 12,
              color: 'green',
              // align: "center",
            },
            s: {
              fontSize: 12,
              color: '',
            },
            l: {
              fontSize: 12,
              color: '#ff5b19',
            },
          },
        },
        center: ['45%', '50%'], //距离左右，上下距离的百分比
        indicator: [
          { text: 'BMS总电流测量精度' },
          { text: '动力电池温差' },
          // { text: "电池等效直流内阻" },
          // { text: "电池告警" },
          { text: 'SOH' },
          // { text: "电池绝缘性" },
          { text: '电池SOC估计误差' },
          // { text: "电池充电电流超限" },
          // { text: "电池系统总电压超限" },
          { text: 'BMS总电压测量精度' },
        ],

        radius: 50,
      },
      series: [
        {
          type: 'radar',
          areaStyle: {
            color: '#e3f2eb',
          },
          color: '#74bd98',

          data: [
            {
              value: [...arr],
              label: {
                // show: true,
                // formatter: function (params) {
                //   return params.value;
                // },
              },
            },
          ],
        },
      ],
    }
    option && myChart.setOption(option)
  }

  htmlToCanvas() {
    this.isDom = (this.$refs as any).imageDom.style.paddingBottom = '30px'
    let that = this
    this.Overlay = true
    this.$dialog.confirm({
      title: '确定将报告生成图片',
      beforeClose(action, done) {
        if (action === 'confirm') {
          done()
          that.Overlay = false
          that.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
          })
          that.toimg()
        } else {
          done()
          that.Overlay = false
          that.isDom = true
        }
      },
    })
  }

  toimg() {
    this.$nextTick(() => {
      setTimeout(() => {
        setTimeout(() => {
          html2canvas((this.$refs as any).imageDom, {
            scale: 1.9,
            useCORS: true,
          }).then((canvas) => {
            let imageUrl = canvas.toDataURL('image/png') // 将canvas转成base64图片格式
            this.canvasImageUrl = imageUrl
            this.$router.push({
              path: '/webPng',
              query: { canvasImageUrl: this.canvasImageUrl },
            })
          })
        }, 1000)
      }, 2000)
    })
  }
  mounted() {
    this.getReportList()
    this.reqdata = localStorage.getItem('shopData')
    console.log(this.reqdata)
    console.log(this.bgimgs)
  }
  getReportList() {
    // 
    getReport(this.orderId).then((res) => {
      if (res.data.code == 1001) {
        // this.$toast('非法访问')
        // this.$router.go(-1)
      }
      this.project = {
        name: res.data.data.name,
        enterpriseName: res.data.data.enterpriseName,
      }
      this.list = res.data.data.thirdPartyRglBaseDataEntity
      this.online = res.data.data.onlineitemsDataEntities
      this.offline = res.data.data.offlineitemsDataEntities

      this.thirdParty = res.data.data.thirdPartyRglChargeDetectionDataEntity
      this.bgimgs = res.data.data.chartDataEntity
      console.log(this.bgimgs)
      this.souh = (100 - this.offline.sohCheckValue + 0).toFixed(2)
      this.Charts(res)
    }).catch(()=>{
      this.$toast('非法访问')
    })
  }
  created() {
    this.orderId = this.$route.query.orderId
  }
}
